/*  ========================================================================
    # Section - Timeline
    ========================================================================  */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { theme } from '../../../../tailwind.config';

// Components
import TimelineEntry from './TimelineEntry';
import Lightbox from '../../components/Lightbox';
import LazyImage from '../../components/LazyImage';
import LazySource from '../../components/LazySource';

const Timeline = ({ entries }) => {
  const breakpoints = theme.screens;
  const [lightboxImage, setLightboxImage] = useState(null);
  const [lightboxIsOpen, setLightboxIsOpen] = useState(false);

  return (
    <>
      <div className='s-timeline__line'>
        <div className='s-timeline__line-dots' />
        <div className='s-timeline__line-scrollbar' />
      </div>
      {entries.map((entry, index) => (
        <TimelineEntry
          key={`${entry.year}-${index}`}
          entryIndex={index}
          entry={entry}
          setLightboxImage={setLightboxImage}
          setLightboxIsOpen={setLightboxIsOpen}
        />
      ))}
      {lightboxImage ? (
        <Lightbox openLightbox={lightboxIsOpen} onCloseLightbox={() => setLightboxIsOpen(false)}>
          <LazyImage
            alt={lightboxImage.image.alt}
            defaultUrl={lightboxImage.image.sizes.medium_large}
            placeholderUrl={lightboxImage.image.sizes.placeholder}
            figureClass=''
          >
            <LazySource srcSet={lightboxImage.image.sizes['2048x2048']} mediaMin={breakpoints.lg} />
            <LazySource srcSet={lightboxImage.image.sizes['1536x1536']} mediaMin={breakpoints.md} />
            <LazySource srcSet={lightboxImage.image.sizes.large} mediaMin={breakpoints.sm} />
          </LazyImage>
        </Lightbox>
      ) : null}
    </>
  );
};

Timeline.propTypes = {
  entries: PropTypes.array
};

export default Timeline;
